function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1267 1600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.868,322.418L385.697,530.875L870.266,563.789L903.181,320.59L383.868,322.418Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.888889,0,0,0.888889,-161.609,63.2634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 757.351,
    cy: 450.259,
    r: 33.704,
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(77,77,77)",
      strokeWidth: "14.06px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.888889,0,0,0.888889,79.4688,63.2634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 757.351,
    cy: 450.259,
    r: 33.704,
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(77,77,77)",
      strokeWidth: "14.06px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.6e5dda94cb48648d22856dc109d2c941.svg";
export { ForwardRef as ReactComponent };